const Features = ({
    displayMessagesCount = false,
    enableConnectedExperience = false,
    enableEmailRedirect = false,
    canAccessFeedClaimAndConvert = false,
    canDeactivateFeedListing = false,
} = {}) => ({
    displayMessagesCount: Boolean(displayMessagesCount),
    enableConnectedExperience: Boolean(enableConnectedExperience),
    enableEmailRedirect: Boolean(enableEmailRedirect),
    canAccessFeedClaimAndConvert: Boolean(canAccessFeedClaimAndConvert),
    canDeactivateFeedListing: Boolean(canDeactivateFeedListing),
});

const Config = ({
    features = {},
} = {}) => ({
    features: Features(features),
});

// only expose config property
// keeping the data model the same structure as response
// in order to easily add other properties
const AppConfig = ({
    config = {},
} = {}) => ({
    config: Config(config),
});

export {
    Features,
};

export default AppConfig;
